<div class="align-content" data-cy="align-content">
  <div class="reports-header" data-cy="reports-header">
    <h2 data-cy="header-title">COTAS CONTEMPLADAS</h2>
    <div class="report-date" data-cy="report-date">
      De {{ startDate | date: "dd/MM/yyyy" }} a {{ endDate | date: "dd/MM/yyyy" }}
    </div>
  </div>

  <div *ngIf="isLoading" class="loading-spinner-container" data-cy="loading-spinner-container">
    <mat-spinner class="spinner" data-cy="loading-spinner"></mat-spinner>
  </div>

  <app-bar-chart
    *ngIf="!isLoading"
    [chartLabels]="chartLabelsX"
    [chartData]="chartData"
    data-cy="bar-chart"
  ></app-bar-chart>
</div>